<template>
  <svg
    width="162"
    height="160"
    viewBox="0 0 162 160"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.06"
      d="M80 140C113.137 140 140 113.137 140 80C140 46.8629 113.137 20 80 20C46.8629 20 20 46.8629 20 80C20 113.137 46.8629 140 80 140Z"
      fill="url(#paint0_linear_10083_72871)"
    />
    <g filter="url(#filter0_d_10083_72871)">
      <path
        d="M136.044 43.8972L139.124 110.864C139.237 113.319 137.126 115.442 134.45 115.565L30.3311 120.355C27.6547 120.478 25.3577 118.558 25.2447 116.103L22.164 49.1361C22.051 46.6812 24.1621 44.5581 26.8384 44.435L130.957 39.6451C133.634 39.5219 135.931 41.4422 136.044 43.8972Z"
        fill="url(#paint1_linear_10083_72871)"
      />
      <path
        d="M135.045 43.9431L138.125 110.91C138.209 112.733 136.611 114.464 134.404 114.566L30.2851 119.356C28.0775 119.457 26.3276 117.88 26.2437 116.057L23.1629 49.0902C23.079 47.2664 24.6768 45.5355 26.8844 45.434L131.003 40.644C133.211 40.5425 134.961 42.1194 135.045 43.9431Z"
        stroke="#67B1FF"
        stroke-opacity="0.5"
        stroke-width="2"
      />
    </g>
    <rect
      opacity="0.06"
      x="61.0117"
      y="57.0177"
      width="24"
      height="11"
      rx="2"
      transform="rotate(-2.63402 61.0117 57.0177)"
      fill="url(#paint2_linear_10083_72871)"
    />
    <rect
      opacity="0.06"
      x="61.6553"
      y="71.0031"
      width="41"
      height="11"
      rx="2"
      transform="rotate(-2.63402 61.6553 71.0031)"
      fill="url(#paint3_linear_10083_72871)"
    />
    <rect
      opacity="0.06"
      x="62.2983"
      y="84.9884"
      width="58"
      height="11"
      rx="2"
      transform="rotate(-2.63402 62.2983 84.9884)"
      fill="url(#paint4_linear_10083_72871)"
    />
    <rect
      opacity="0.06"
      x="62.9419"
      y="98.9733"
      width="33"
      height="11"
      rx="2"
      transform="rotate(-2.63402 62.9419 98.9733)"
      fill="url(#paint5_linear_10083_72871)"
    />
    <path
      opacity="0.16"
      d="M27.5988 57.5526C27.5227 55.8975 28.8027 54.4941 30.4578 54.4179L52.4345 53.4069C54.0896 53.3307 55.4931 54.6107 55.5692 56.2658L58.0616 110.443C58.1378 112.098 56.8578 113.501 55.2026 113.577L33.2259 114.588C31.5708 114.665 30.1673 113.385 30.0912 111.729L27.5988 57.5526Z"
      fill="url(#paint6_linear_10083_72871)"
    />
    <path
      d="M32.2319 62.3429L47.7194 61.6304"
      stroke="white"
      stroke-width="2"
      stroke-miterlimit="10"
    />
    <path
      d="M32.5879 70.0865L45.1715 69.5076"
      stroke="white"
      stroke-width="2"
      stroke-miterlimit="10"
    />
    <path
      d="M32.9443 77.8307L49.3998 77.0737"
      stroke="white"
      stroke-width="2"
      stroke-miterlimit="10"
    />
    <path
      d="M33.3003 85.5743L40.0761 85.2626"
      stroke="white"
      stroke-width="2"
      stroke-miterlimit="10"
    />
    <path
      d="M33.6567 93.318L47.2083 92.6946"
      stroke="white"
      stroke-width="2"
      stroke-miterlimit="10"
    />
    <path
      d="M34.0132 101.062L42.7249 100.661"
      stroke="white"
      stroke-width="2"
      stroke-miterlimit="10"
    />
    <path
      d="M136.002 44.3046L136.165 47.8476L22.3456 53.0838L22.1826 49.5409C22.0594 46.864 24.1609 44.5582 26.8358 44.4351L130.9 39.6477C133.575 39.5246 135.879 41.6278 136.002 44.3046Z"
      fill="#67AFFF"
    />
    <path
      d="M27.3361 50.1717C28.1616 50.1337 28.8001 49.4332 28.7621 48.607C28.7241 47.7809 28.024 47.1419 27.1984 47.1799C26.3729 47.2179 25.7344 47.9184 25.7724 48.7446C25.8104 49.5707 26.5105 50.2097 27.3361 50.1717Z"
      fill="#EAEEF9"
    />
    <path
      opacity="0.6"
      d="M31.9782 49.9582C32.8037 49.9202 33.4422 49.2197 33.4042 48.3935C33.3662 47.5674 32.6661 46.9284 31.8405 46.9664C31.015 47.0044 30.3765 47.7049 30.4145 48.5311C30.4525 49.3572 31.1526 49.9962 31.9782 49.9582Z"
      fill="#EAEEF9"
    />
    <path
      opacity="0.4"
      d="M36.6984 49.7409C37.5239 49.7029 38.1624 49.0024 38.1244 48.1762C38.0864 47.3501 37.3863 46.7111 36.5607 46.7491C35.7352 46.7871 35.0967 47.4876 35.1347 48.3138C35.1727 49.1399 35.8728 49.7789 36.6984 49.7409Z"
      fill="#EAEEF9"
    />
    <g filter="url(#filter1_d_10083_72871)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M115.899 63.963C115.301 63.891 114.868 63.3461 114.94 62.7478C115.012 62.1494 115.549 61.7214 116.147 61.7935L116.16 61.7951C116.759 61.8671 117.186 62.4112 117.114 63.0096C117.042 63.608 116.498 64.0351 115.899 63.963ZM116.226 52.0594C116.298 51.4611 116.842 51.0339 117.441 51.106C118.039 51.1781 118.466 51.7222 118.394 52.3206L117.716 57.9501C117.644 58.5485 117.1 58.9756 116.501 58.9035C115.903 58.8315 115.476 58.2874 115.548 57.689L116.226 52.0594ZM127.225 55.8154L126.984 55.238C123.593 47.0434 121.254 43.8673 118.355 43.5181C115.455 43.1689 112.429 45.6988 107.189 52.8537L106.819 53.3575C104.94 55.8908 101.036 61.161 101.228 64.6094C101.452 68.6877 105.486 69.8276 115.047 70.9792C124.609 72.1309 128.799 71.9816 129.984 68.0729C130.989 64.7688 128.447 58.7221 127.225 55.8154Z"
        fill="url(#paint7_linear_10083_72871)"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_10083_72871"
        x="0.159668"
        y="28.6395"
        width="160.969"
        height="124.721"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0117647 0 0 0 0 0.466667 0 0 0 0 1 0 0 0 0.16 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_10083_72871"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_10083_72871"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_10083_72871"
        x="97.2207"
        y="43.4867"
        width="36.9927"
        height="36.1195"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0156863 0 0 0 0 0.478431 0 0 0 0 1 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_10083_72871"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_10083_72871"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_10083_72871"
        x1="19.9981"
        y1="139.999"
        x2="139.999"
        y2="19.9985"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_10083_72871"
        x1="78.7799"
        y1="40.2857"
        x2="82.391"
        y2="118.78"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDFEFF" />
        <stop offset="0.9964" stop-color="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_10083_72871"
        x1="61.0113"
        y1="68.0176"
        x2="69.3442"
        y2="49.8368"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_10083_72871"
        x1="61.6546"
        y1="82.003"
        x2="67.1607"
        y2="61.4802"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_10083_72871"
        x1="62.2974"
        y1="95.9883"
        x2="66.325"
        y2="74.7521"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_10083_72871"
        x1="62.9414"
        y1="109.973"
        x2="69.5414"
        y2="90.1731"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_10083_72871"
        x1="30.2286"
        y1="114.726"
        x2="75.2457"
        y2="91.2259"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_10083_72871"
        x1="100.595"
        y1="69.2384"
        x2="131.497"
        y2="43.6768"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script setup></script>
